import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import OrganizationsPage from './pages/OrganizationsPage';
import AuthorsPage from './pages/AuthorsPage';
import ClipsPage from './pages/ClipsPage';
import BiliBiliToolPage from './pages/BiliBiliToolPage';
import SubtitlePage from './pages/SubtitlePage';
import SummaryPage from './pages/SummaryPage';
import DesktopReleasesPage from './pages/DesktopReleasesPage';
import LoginPage from './pages/LoginPage'; // 引入登录页面
import PrivateRoute from './components/PrivateRoute'; // 引入私有路由

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="organizations" element={<OrganizationsPage />} />
            <Route path="authors" element={<AuthorsPage />} />
            <Route path="clips" element={<ClipsPage />} />
            <Route path="/bili-tool" element={<BiliBiliToolPage />} />
            <Route path="/subtitles" element={<SubtitlePage />} />
            <Route path="/summaries" element={<SummaryPage />} />
            <Route path="/desktop-releases" element={<DesktopReleasesPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;